import { FETCH_SHOOTING_DAY_SET_DRESSINGS } from "./actions";

const defaultState = {
  props: [],
  loading: true,
  readOnly: false,
  errors: null
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_SHOOTING_DAY_SET_DRESSINGS + "_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case FETCH_SHOOTING_DAY_SET_DRESSINGS + "_FULFILLED": {
      return {
        ...state,
        setDressings: action.payload.data.setDressings,
        readOnly: action.payload.data.readOnly,
        loading: false,
        errors: null
      };
    }

    case FETCH_SHOOTING_DAY_SET_DRESSINGS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
